import { FC, Fragment, useState } from "react";
import { Link } from "react-router-dom";
import "./Dropdown.css";
import MenuItem from "../../../types/MenuItem";
import { Divider } from "@mui/material";
import UserInformation from "../../../types/UserInformation";
import { profilToAccessToAllFonctionnality } from "../../../constants/Constants";
import { useDispatch } from "react-redux";
import { deleteArticleInformationParam } from "../../../redux/actions/articleParam";

export interface DropdownMenuProps {
  menuItems?: MenuItem[];
  user: UserInformation;
}

const Dropdown: FC<DropdownMenuProps> = ({ menuItems, user }) => {
  const [click, setClick] = useState(false);
  const dispatch = useDispatch();

  const handleClick = () => {
    setClick(false);
    // Suppremer l Article Info Dans Redux
    dispatch(deleteArticleInformationParam());
  };

  const normalItemMenu = (item: MenuItem, index: number) => {
    return (
      <Fragment>
        <li key={index}>
          <Link className={item.cName} to={item.path} onClick={handleClick}>
            {item.title}
          </Link>
        </li>
        <Divider sx={{ color: "#201f1e" }} />
      </Fragment>
    );
  };

  const deFaultMenuItem = (item: MenuItem, index: number) => {
    if (user?.profils?.libelle && profilToAccessToAllFonctionnality?.includes(user?.profils?.libelle)) {
      return normalItemMenu(item, index);
    } else {
      if (user?.updated_password) {
        if (user?.features?.includes(item.code)) {
          return normalItemMenu(item, index);
        }
      }
    }
  };

  return (
    <>
      <ul className={click ? "dropdown-menu clicked" : "dropdown-menu"}>
        {menuItems!.map((item, index) => {
          return deFaultMenuItem(item, index);
        })}
      </ul>
    </>
  );
};

export default Dropdown;
